"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MergingStatusIterator = exports.MergingStatusIterator = function () {
    /**
     * @param it              Iterator<Status>
     * @param maxIterations   Int
     */
    function MergingStatusIterator(_ref) {
        var _ref$it = _ref.it,
            it = _ref$it === undefined ? null : _ref$it,
            _ref$maxIterations = _ref.maxIterations,
            maxIterations = _ref$maxIterations === undefined ? null : _ref$maxIterations;

        _classCallCheck(this, MergingStatusIterator);

        this._it = it;
        this._maxIterations = maxIterations;
        this._nextStatus = this._it !== null && this._it.hasNext() ? this._it.next() : null;
    }

    _createClass(MergingStatusIterator, [{
        key: "hasNext",
        value: function hasNext() {
            return this._nextStatus != null;
        }

        /** @return Status */

    }, {
        key: "next",
        value: function next() {
            var mergedStatus = this._nextStatus;

            var iteration = 0;
            while (true) {
                if (!this._it.hasNext()) {
                    this._nextStatus = null;
                    break;
                }
                this._nextStatus = this._it.next();
                if (!this._statusEqualsIgnoreUntil(this._nextStatus, mergedStatus)) {
                    break;
                }
                mergedStatus.until = this._nextStatus.until;

                if (this._maxIterations !== null && iteration++ >= this._maxIterations) {

                    // TODO: Patch. Without this a DisjunctiveTimeWindowsIterator using a DisjunctiveTimeWindowsIterator, both
                    // using a MergingStatusIterator with a maxIterations of 1000, take a ***** very ***** long time to run (since
                    // the external MergingStatusIterator will run 1000 of the internal's 1000.
                    //
                    // Solution: DisjunctiveTimeWindowsIterator v2.
                    mergedStatus.until = null;
                    this._nextStatus = null;
                    break;
                }
            }
            return mergedStatus;
        }
    }, {
        key: "_stringMapEquals",
        value: function _stringMapEquals(map1, map2) {
            if (!map1) {
                return map2 ? false : true;
            } else if (!map2) {
                return false;
            }

            for (var key in map1) {
                if (map1[key] !== map2[key]) {
                    return false;
                }
            }
            for (var _key in map2) {
                if (map2[_key] !== map1[_key]) {
                    return false;
                }
            }
            return true;
        }
    }, {
        key: "_statusEqualsIgnoreUntil",
        value: function _statusEqualsIgnoreUntil(status1, status2) {
            return status1.status === status2.status && status1.reason === status2.reason && this._stringMapEquals(status1.comment, status2.comment);
        }
    }]);

    return MergingStatusIterator;
}();


//////////////////
// WEBPACK FOOTER
// ../node_modules/availability/dist/iterators/MergingStatusIterator.js
// module id = 262
// module chunks = 0